import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useNavigate, useParams } from 'react-router-dom';
import PageWrapper from '../components/pageWrapperHOC';
import { ProfileContextProvider } from '../common/context/profile/context';
import FeaturedSuccessStories from '../components/profile/FeaturedSuccessStories';
import CompanyInformation from '../components/profile/CompanyInformation';
import Feedback from '../components/srp/Feedback';
import Services from '../components/profile/Services';
import SecondaryNavigation from '../components/srp/SecondaryNavigation';
import ProfileHeroBanner from '../components/profile/ProfileHeroBanner';
import Specializations from '../components/profile/Specializations';
import Solutions from '../components/profile/Solutions';
import TermsOfUse from '../components/srp/TermsOfUse';
import Accreditations from '../components/profile/Accreditations';
import Overview from '../components/profile/Overview';
import ExploreSuccessStories from '../components/profile/ExploreSuccessStories';
import ProfileTabs from '../components/profile/Tabs';
import Affiliations from '../components/profile/Affiliations.js';
import { BASENAME } from '../common/constants';
import { getBaseURL } from '../common/utilities';

const Profile = ({ store }) => {
  const navigate = useNavigate();
  const params = useParams(); // replaces match.params
  const navigateToUrl = (path) => {
    const baseUrl = getBaseURL(params.locale, path);
    navigate(baseUrl);
  };
  const detailBack = () => {
    const search = sessionStorage.getItem('srpSearch');
    const param = search || '';
    const defaultPath = `${BASENAME}${param}`;
    navigateToUrl(defaultPath);
  };

  return (
    <ProfileContextProvider store={store} params={params}>
      <PageWrapper>
        <RootElement>
          <SecondaryNavigation onBack={detailBack} backBtnText="Back to Partner Finder" />
          <ProfileHeroBanner />
          <ProfileTabs />
          <Overview />
          <FeaturedSuccessStories />
          <CompanyInformation />
          <Affiliations />
          <Services />
          <Specializations />
          <Solutions />
          <Accreditations />
          <ExploreSuccessStories />
          <Feedback />
          <TermsOfUse showTerms={false} />
        </RootElement>
      </PageWrapper>
    </ProfileContextProvider>
  );
};

const RootElement = styled.div``;

Profile.propTypes = {
  store: PropTypes.shape({}),
};
Profile.defaultProps = {
  store: {},
};
export default Profile;
